import SettingsIcon from "@mui/icons-material/Settings";
import MadrasaSettingsPage from "./MadrasaSettingsPage";

export default {
  list: MadrasaSettingsPage,
  icon: SettingsIcon,
  label: "Madrasa settings",
  options: { label: "Madrasa settings" },
  name: "madrasaSettings",
};
